module.exports = __webpack_public_path__ + "static/img/SIENNA_MAPLE.e4cdf39.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/SIENNA_MAPLE.jpg
// module id = T9xq
// module chunks = 0